export const FETCH_COMPETITIONS_REQUESTED =
  'competitions/FETCH_COMPETITIONS_REQUESTED'
export const FETCH_COMPETITIONS_SUCCEEDED =
  'competitions/FETCH_COMPETITIONS_SUCCEEDED'
export const FETCH_COMPETITIONS_FAILED =
  'competitions/FETCH_COMPETITIONS_FAILED'



// WEBPACK FOOTER //
// ./src/store/token/actionTypes.js